import { useEffect, useRef, useState } from "react";

export const useDashboardFilterHide = (distance: number) => {
    const [showControls, setShowControls] = useState(false); // Da li se kontrole prikazuju
    const [hasAnimated, setHasAnimated] = useState(false); // Da li je animacija završena
    const scrollRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const handleScroll = () => {
            if (scrollRef.current) {
                const scrollTop = scrollRef.current.scrollTop;

                // Ako je skrolovao više od 300px, prikaži kontrole, a animiraj ih
                if (scrollTop > distance) {
                        setShowControls(true);
                        setHasAnimated(true); 
                        
                    } else {
                        if(hasAnimated){
                            
                            setShowControls(false);
                        }
                }
            }
        };

        const currentScrollRef = scrollRef.current;

        if (currentScrollRef) {
            currentScrollRef.addEventListener("scroll", handleScroll);
        }

        return () => {
            if (currentScrollRef) {
                currentScrollRef.removeEventListener("scroll", handleScroll);
            }
        };
    }, [hasAnimated]);

    return { showControls, hasAnimated, scrollRef };
};
